export const formatYYYYMMDD = (date) => date.toISOString().split('T')[0];

export const isADate = (date) => Object.prototype.toString.call(date) === '[object Date]';

export const tzDataBaseName = Intl.DateTimeFormat().resolvedOptions().timeZone;
